import { useState, useEffect } from 'react';
import { defaultRequiredProperty } from '../utils/webinarFormUtils';
import { formEligible } from '../../api/formApi';
export const useFormEligible = formGuid => {
  const [isFormEligible, setIsFormEligible] = useState(false);
  const [isFormEligibleLoading, setIsFormEligibleLoading] = useState(true);
  const [formEligibleError, setFormEligibleError] = useState(null);
  useEffect(() => {
    formEligible(formGuid, defaultRequiredProperty).then(response => {
      setIsFormEligible(response);
    }).catch(error => {
      // add error handling
      setFormEligibleError(error);
    }).finally(() => {
      setIsFormEligibleLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    isFormEligible,
    isFormEligibleLoading,
    formEligibleError
  };
};